import React from 'react';

function UpDownArrowsNew() {
  return (
    <svg xmlns="http://www.w3.org/2000/svg" width="16" height="20" viewBox="0 0 16 20" fill="none">
      <path d="M4.98211 19.2403L4.98211 9.08388M9.21369 15.0083L4.98185 19.2402L0.75 15.0083M10.1888 0.75L10.1888 10.9064M5.95723 4.982L10.1891 0.750153L14.4209 4.982" stroke="#08081B" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round"/>
    </svg>  )
  ;
}

export default UpDownArrowsNew;